var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCloseChat = function SvgCloseChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.5,
    height: 23.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 551"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "M7.05 5.875l4.7 4.7 4.7-4.7a.831.831 0 011.175 1.175l-4.7 4.7 4.7 4.7a.831.831 0 01-1.175 1.175l-4.7-4.7-4.699 4.7a.831.831 0 01-1.175-1.176l4.699-4.698-4.7-4.7a.831.831 0 011.176-1.175z"
  }))));
};
export default SvgCloseChat;